import { render, staticRenderFns } from "./PlateNeedDetails.vue?vue&type=template&id=469ae5c2&scoped=true&"
import script from "./PlateNeedDetails.vue?vue&type=script&lang=js&"
export * from "./PlateNeedDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlateNeedDetails.vue?vue&type=style&index=0&id=469ae5c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ae5c2",
  null
  
)

export default component.exports